import { FilterConfig } from 'common/models/filter.model';
import { FILTER_ITEMS } from './constants-filter-configs';

export const TEAM_PROFILE_DETAIL_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.specialty,
  FILTER_ITEMS.tags,
  FILTER_ITEMS.profile,
];
export const TEAM_PROFILE_DETAIL_SEGMENT_FILTER: FilterConfig[] = [
  FILTER_ITEMS.duration,
  FILTER_ITEMS.specialty,
  FILTER_ITEMS.product,
  FILTER_ITEMS.accountCountry,
  FILTER_ITEMS.channel,
  FILTER_ITEMS.topic,
  FILTER_ITEMS.category,
];
